import React, { FunctionComponent } from 'react';

import { ICaptureConfig } from 'interfaces';
import { Button, ButtonGroup, Tooltip } from 'cfa-react-components';
import { CaptureConfigService } from 'services';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ICaptureConfigItemProps {
    config: ICaptureConfig,
    onEditCaptureConfig: (c: ICaptureConfig) => void,
    openDeleteModal: (target: any, deleteFunc: (any) => Promise<any>, deleteVerb: string, deleteNoun: string) => void,
    refresh: () => void,
}

export const CaptureConfigItem: FunctionComponent<ICaptureConfigItemProps> = ({ config, onEditCaptureConfig, openDeleteModal, refresh }) => {

    return (
        <tr key={config.captureConfigUUID}>
            <td className='configTable_item'>
                {config.name}<br/>
                <p style={{fontSize: '12px', margin: '6px 6px 0px'}}>{config.captureConfigUUID}</p>
            </td>
            <td className='configTable_item'>{config.sourceType}</td>
            <td className='configTable_item'>{config.sourceParams.location}</td>
            <td className='configTable_item'>{config.sourceParams.secretPath}</td>
            <td className='configTable_item'>{config.durationMinutes}</td>
            <td className='configTable_item'>{config.delayMinutes}</td>
            <td className='configTable_item'>{config.TTL}</td>
            <td className='configTable_item configTable_itemButton'> 
                <ButtonGroup size='sm'>
                    <Tooltip content="Edit" showOnElementDelay={{showDelay: 1000}}>
                        <Button className="itemTable_iconButton" color='secondary'
                            onClick={() => onEditCaptureConfig(config)}>
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    </Tooltip>
                    <Tooltip content="Delete" showOnElementDelay={{showDelay: 1000}}>
                        <Button className="itemTable_iconButton" variant="destructive"
                            onClick={() => openDeleteModal(config.captureConfigUUID, CaptureConfigService.deleteCaptureConfig, "Delete", "Capture Config")} >
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    </Tooltip>
                </ButtonGroup>
            </td>
        </tr>
    );
}